<template>
    <div class="wrap" v-if="isDoneLoadInitData && questions && !!questions.length">
        <div class="bx_back" @click="$router.back()">
            <a class="btn_back">{{$t('common_previousPage')}}</a>
        </div>

        <div class="bx_round_white bx_info_txt" v-if="isBeforeEnrolment || isEndEnrolment">
            <p class="info_txt">
                <span class="point_red"
                      v-text="isBeforeEnrolment ? this.$t('EnrolmentResponseDefault_noApplyDate') : isEndEnrolment ? this.$t('EnrolmentResponseDefault_endedApply') : null"></span>
                <small v-if="isBeforeEnrolment">{{periodText}}</small>
            </p>
        </div>

        <div class="bx_round_white card_news">
            <div class="bx_card_news detail type3">
                <ResponseTitle
                    :title="survey.title"
                    :writer="survey.schoolName"
                    :send-date-string="survey.sendDate"
                />

                <div class="bx_cont">
                    <div class="cont">
                        <ResponseDescText
                            :survey-desc="surveyDesc"
                            :images="surveyImages"
                            :is-webview="isWebView"
                        />

                        <ResponseFile
                            :documents="surveyDocuments"
                        />

                        <form action="#">
                            <fieldset>
                                <div class="bx_survey info">
                                    <h3 class="title small">{{$t('EnrolmentResponse_enrolmentInfo')}}</h3>
                                    <ul class="lst_cont">
                                        <li>
                                            <span class="title">{{$t('EnrolmentResponse_responseState')}} :</span>
                                            <span class="txt"><strong>{{answerStateText}}</strong></span>
                                        </li>
                                        <li>
                                            <span class="title">{{$t('EnrolmentResponse_responseTarget')}} :</span>
                                            <span class="txt">
                                                <HangulWordWrapText :text="survey.receiverName" :split-regex="/, +/" inter-text=", "/>
                                            </span>
                                        </li>
                                        <li>
                                            <span class="title" v-if="isBeforeEnrolment">{{$t('EnrolmentResponse_startAt')}} :</span>
                                            <span class="title" v-else>{{$t('EnrolmentResponse_endAt')}} :</span>
                                            <span class="txt">
                                                <span class="point_red has_bar">{{periodStateText}}</span>
                                                <span class="time">{{periodTimeText}}</span>
                                            </span>
                                        </li>
                                        <li>
                                            <span class="title">{{$t('EnrolmentResponse_selectionMethod')}} :</span>
                                            <span class="txt"><strong>{{enrolmentTypeName}}</strong></span>
                                        </li>
                                    </ul>
                                </div>

                                <legend>{{$t('EnrolmentResponse_blind_surveyArea')}}</legend>

                                <div class="bx_survey attend" v-if="!isEndEnrolment">
                                    <h3 class="title">{{$t('EnrolmentResponse_confirmApplyEnrolment')}}
                                        <span class="required">{{$t('EnrolmentResponse_mandatory')}}</span>
                                    </h3>
                                    <div class="bx_btn">
                                        <button type="button" class="btn_attend" :class="{on : answerStateType === answerStateTypeDeny}"
                                                @click="changeAnswerState(answerStateTypeDeny, $event)">
                                            {{$t('EnrolmentResponse_doNotApply')}}
                                        </button>
                                        <button type="button" class="btn_attend" :class="{on : answerStateType === answerStateTypeAnswer}"
                                                @click="changeAnswerState(answerStateTypeAnswer, $event)">
                                            {{$t('EnrolmentResponse_doApply')}}
                                        </button>
                                    </div>
                                </div>

                                <EnrolmentResponseQuestion v-for="(question, index) in questions" :key="question.questionNo"
                                                           :question="question" :question-index="index"></EnrolmentResponseQuestion>
                            </fieldset>
                        </form>
                    </div>
                </div>

                <div class="bx_footer">
                    <span class="btn_area">
                        <button class="btn_favorite" :class="{on:isScrapedPage}" @click="scrap">{{$t('common_schoolScrap')}}</button>
                    </span>
                </div>
            </div>
        </div>

        <!-- 전체화면 에러 -->
        <FullScreenError :error="error" v-show="hasFullScreenError"></FullScreenError>

    </div>
</template>

<script>
import {ENROLMENT_TYPE, PERIOD_STATE_TYPE} from '@common/consts/survey.js';
import {ERROR_TYPE} from '@/iamteacherpc/consts/errorType.js';

import {toDateFromISOFormat, toResponseViewFormat} from '@/common/utils/date.js';
import {ENROLMENT_RESPONSE_NAMESPACE} from '@/common/store';
import {showToast} from '@/common/utils/simpleToast.js';
import {
    checkUserAgent,
    IAMSCHOOL_AOS_APP_DOWNLOAD_URL,
    IAMSCHOOL_IOS_APP_DOWNLOAD_URL,
    IOS,
} from '@/iamteacherpc/utils/checkMobileDevice.js';
import {responseModal} from '@/common/directives/responseModal.js';

import EnrolmentResponseQuestion from '@/iamschoolpc/components/response/EnrolmentResponseQuestion.vue';
import FullScreenError from '@/iamteacherpc/components/common/FullScreenError.vue';
import {createNamespacedHelpers} from 'vuex';
import responsePage from '@iamschoolpc/mixins/responsePage.js';
import ResponseTitle from '@/iamschoolpc/components/response/ResponseTitle.vue';
import ResponseDescText from '@/iamschoolpc/components/response/ResponseDescText.vue';
import {
    CHANGE_ANSWER_STATE,
    FORCE_CLOSE,
    GET_ENROLMENT_TYPE_NAME,
    INIT_ENROLMENT_DATA,
    IS_AFTER_ENROLMENT_PERIOD,
    IS_AVAILABLE_ENROLMENT_PERIOD,
    SHOW_ERROR,
} from '@/common/store/modules/enrolment/response.js';
import ResponseFile from '@/iamteacherpc/components/response/ResponseFile.vue';
import HangulWordWrapText from '@/common/components/HangulWordWrapText.vue';
import {SURVEY_ANSWER_STATE_TYPE} from '@/common/consts/response.js';
import {$showErrorPage} from '@common/utils/errorPage';
import SimpleErrorMessage from '@iamschoolpc/views/common/SimpleErrorMessage';

const {mapActions, mapGetters, mapState} = createNamespacedHelpers(ENROLMENT_RESPONSE_NAMESPACE);

export default {
    name: 'Response',
    components: {
        HangulWordWrapText,
        ResponseFile,
        ResponseDescText,
        ResponseTitle,
        EnrolmentResponseQuestion,
        FullScreenError,
    },
    directives: {responseModal},
    mixins: [
        responsePage,
    ],

    props: {
        serviceId: {
            type: String,
            required: true,
        },

        isPreview: {
            type: Boolean,
            default: false,
        },

        isScraped: {
            type: Number,
            required: false,
        },

        cardId: {
            type: String,
            required: false,
        }
    },

    data() {
        return {
            type: 'enrolment',
            answerStateTypeDeny: SURVEY_ANSWER_STATE_TYPE.DENY,
            answerStateTypeAnswer: SURVEY_ANSWER_STATE_TYPE.ANSWER,
            isLoadError: false,
            isDoneLoadInitData: false,
            isScrapedPage: Boolean(this.isScraped),
        };
    },

    computed: {
        ...mapState({
            survey: state => state.survey,
            surveyDesc: state => state.survey.surveyDesc,
            surveyImages: state => state.survey.contents.images,
            surveyDocuments: state => state.survey.contents.documents,
            startDateString: state => toResponseViewFormat(state.survey.startDate),
            endDateString: state => toResponseViewFormat(state.survey.endDate),
            sendDateString: state => toResponseViewFormat(state.survey.sendDate),
            startDate: state => state.survey.startDate,
            endDate: state => state.survey.endDate,
            questions: state => state.survey.contents && state.survey.contents.questions,
            answerStateType: state => state.survey.answerStateType,
            periodStateType: state => state.survey.periodStateType,
            receiverAnswerStateType: state => state.survey.receiver.answerStateType,
            answers: state => state.survey.receiver.surveyAnswers,
            error: state => state.error,
        }),

        ...mapGetters({
            enrolmentTypeName: GET_ENROLMENT_TYPE_NAME,
            isAvailableEnrolmentPeriod: IS_AVAILABLE_ENROLMENT_PERIOD,
            isEndEnrolment: IS_AFTER_ENROLMENT_PERIOD,
        }),

        isWebView() {
            return this.$route.query.hasOwnProperty('isMasking');
        },

        schoolWebUrl() {
            if (this.isPreview) {
                return '#';
            }

            return 'https://school.iamservice.net/';
        },

        appDownloadURL() {
            if (this.isPreview) {
                return '#';
            }

            if (checkUserAgent() === IOS) {
                return IAMSCHOOL_IOS_APP_DOWNLOAD_URL;
            }
            return IAMSCHOOL_AOS_APP_DOWNLOAD_URL;
        },

        /**
         * 신청상태에 따른 style 적용
         * @Deprecated
         */
        answerStateClass() {
            //신청안함
            if (this.answerStateType === SURVEY_ANSWER_STATE_TYPE.DENY) {
                return {};
            }

            //신청완료
            if (this.answerStateType === SURVEY_ANSWER_STATE_TYPE.ANSWER && this.answers && this.answers.length > 0) {
                return {point: true, not: false};
            }

            //미신청
            return {point: true, not: true};
        },

        answerStateText() {
            //신청안함
            if (this.answerStateType === SURVEY_ANSWER_STATE_TYPE.DENY) {
                return this.$t('EnrolmentResponseDefault_deny');
            }

            //신청완료
            if (this.answerStateType === SURVEY_ANSWER_STATE_TYPE.ANSWER && this.answers && this.answers.length > 0) {
                return this.$t('EnrolmentResponseDefault_complete');
            }

            //미신청
            return this.$t('EnrolmentResponseDefault_incomplete');
        },

        hasFullScreenError() {
            return this.error.hasError && this.error.errorType === ERROR_TYPE.FULL_SCREEN;
        },

        isBeforeEnrolment(){
            return this.periodStateType === PERIOD_STATE_TYPE.BEFORE_PERIOD;
        },

        periodText() {
            return `${this.$t('EnrolmentResponseDefault_applyDateInfo')} : ${this.startDateString} ~ ${this.endDateString}`;
        },

        periodStateText(){
            if(this.periodStateType === PERIOD_STATE_TYPE.BEFORE_PERIOD){
                return this.$t('EnrolmentResponse_beforeDate');
            } else if(this.periodStateType === PERIOD_STATE_TYPE.ONGOING){
                return this.$t('EnrolmentResponse_ongoing');
            } else {
                return this.$t('EnrolmentResponse_ended');
            }
        },

        periodTimeText() {
            if (this.periodStateType === PERIOD_STATE_TYPE.BEFORE_PERIOD) {
                return this.$t('EnrolmentResponse_startAtDesc', {datetime: this.startDateString});
            } else {
                return this.$t('EnrolmentResponse_endAtDesc', {datetime: this.endDateString});
            }
        }
    },

    watch: {
        /*에러 메세지를 toast로 보여주는 경우*/
        error: function (error) {
            if (error.hasError && error.errorType === ERROR_TYPE.POPUP) {
                showToast(error.resultMessage, this.isWebView);
            }
        },
    },

    methods: {
        ...mapActions({
            changeAnswerStateAction: CHANGE_ANSWER_STATE,
            initEnrolmentData: INIT_ENROLMENT_DATA,
            showError: SHOW_ERROR,
            forceClose: FORCE_CLOSE,
        }),

        //IOS에서 빠르게 반복해서 터치시 더블 탭으로 인식되는 문제로 인해 전체영역 click prevent
        preventClickForIosTouch() {
        },

        changeAnswerState(newAnswerStateType, event) {
            event.preventDefault();

            if (this.isPreview) {
                this.changeAnswerStateAction({answerStateType: newAnswerStateType});
                return;
            }

            if (Date.now() > toDateFromISOFormat(this.endDate)) {
                event.preventDefault();
                this.forceClose();
                return;
            }

            if (newAnswerStateType === SURVEY_ANSWER_STATE_TYPE.DENY) {
                if (this.answers.length > 0) {
                    this.showAllCancelConfirm();
                    return;
                }

                this.changeAnswerStateAction({answerStateType: newAnswerStateType});
            }

            if (newAnswerStateType === SURVEY_ANSWER_STATE_TYPE.ANSWER) {
                if (this.answerStateType === SURVEY_ANSWER_STATE_TYPE.DENY) {
                    this.$showConfirm({
                        title: this.$t('EnrolmentResponseDefault_confirmApplyEnrolment'),
                        desc: this.$t('EnrolmentResponseDefault_confirmApplyEnrolmentDesc'),
                        okText: this.$t('EnrolmentResponseDefault_confirmApplyEnrolmentOk'),
                        ok: () => {
                            this.changeAnswerStateAction({answerStateType: newAnswerStateType});
                        },
                    });
                } else {
                    this.changeAnswerStateAction({answerStateType: newAnswerStateType});
                }
            }
        },

        confirmDenyYes() {
            this.changeAnswerStateAction({answerStateType: SURVEY_ANSWER_STATE_TYPE.DENY})
                .then(() => {
                    showToast(this.$t('EnrolmentResponseDefault_allEnrolmentCanceled'), this.isWebView);
                });
        },

        /**
         * 페이지 이탈방지 설정
         *
         */
        setPageUnload() {
            window.onbeforeunload = event => {
                if (this.isAvailableAnswer()) {
                    event.returnValue = this.$t('EnrolmentResponseDefault_movePageAlert');
                }
            };
        },

        //신청가능한 강좌가 존재하는지 여부
        isAvailableAnswer() {
            //신청하겠습니다 선택이 아닌경우 (미신청, 신청하지 않겠습니다 선택인경우)
            if (this.answerStateType !== SURVEY_ANSWER_STATE_TYPE.ANSWER) {
                return false;
            }
            //신청기간
            if (!this.isAvailableEnrolmentPeriod) {
                return false;
            }

            //최대선택갯수 미만으로 선택한 수강신청들
            const availableAnswerQuestions = this.questions.filter(question => {
                //해당 수강신청의 프로그램 전부 신청
                if (question.choiceCount >= question.programs.length) {
                    return false;
                }
                return question.maxChoice === 0 || (question.maxChoice > question.choiceCount);
            });

            if (availableAnswerQuestions.length === 0) {
                return false;
            }

            //추첨인 경우 정원 확인할 필요없음
            if (this.survey.enrolmentType === ENROLMENT_TYPE.RANDOM) {
                return true;
            }

            //가능한 수강신청의 프로그램중 수신자가 신청도 안했고 && 정원마감이 아닌프로그램이 존재
            return availableAnswerQuestions.find(question => question.programs.find(program => {
                return !program.answer && (program.limit + program.reservedLimit > program.answerTotalCount);
            }));
        },

        /**
         * 신청 상태에서 '신청하지 않습니다' 선택했을 경우 전체 신청취소 확인팝업
         */
        showAllCancelConfirm() {
            this.$showConfirm({
                title: this.$t('EnrolmentResponse_schoolConfirmCancelApply'),
                desc: this.$t('EnrolmentResponse_schoolConfirmCancelApplyDesc'),
                okText: this.$t('EnrolmentResponse_cancelApply'),
                cancelText: this.$t('common_no'),
                ok: async () => {
                    await this.confirmDenyYes();
                },
                cancel: async () => {
                    await this.confirmDenyNo();
                },
            });
        },

        scrap(){
            if(this.isScrapedPage){
                window.schoolLayout.unScrap(this.cardId).then(
                    result => {
                        if(result){
                            this.isScrapedPage = false;
                        }
                    }
                );
            }else{
                window.schoolLayout.scrap(this.cardId).then(
                    result => {
                        if(result){
                            this.isScrapedPage = true;
                        }
                    }
                );
            }
        },
    },

    created() {
        $showErrorPage({
            component: SimpleErrorMessage, payload: {
                message: '해당 수강신청은 아이엠스쿨 학부모 전용앱에서 확인하실 수 있습니다.',
            },
        });

        // this.isDoneLoadInitData = true;
        // if (!this.questions.length) {
        //     this.showError({
        //         hasError: true,
        //         errorType: ERROR_TYPE.FULL_SCREEN,
        //         resultCode: 0,
        //         resultMessage: this.$t('EnrolmentResponseDefault_noTargetGrade'),
        //     });
        // }
        //
        // if (!this.survey.receiver.isRead) {
        //     // 읽음처리 API는 응답을 기다리지 않음
        //     responseApi.patchSurveyReceiverRead({
        //         surveyNo: this.survey.surveyNo,
        //         surveyReceiverNo: this.survey.receiver.surveyReceiverNo,
        //     });
        // }
    },

    mounted() {
        this.setPageUnload();
    },
};
</script>

<style scoped>
a {
    cursor: pointer
}
</style>

